import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Col,
  Container,
  Row,
  Badge,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import DataTable from '../../../shared/components/DataTable';
import renderToggleButtonField from '../../../shared/components/form/ToggleButton';

import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import {
  filterHomework,
  removeHomework,
} from '../../../redux/actions/materiaPeriodoActions';
import Confirm from '../../../shared/components/Confirm';
import {
  dateFormat,
  dateTimeFormat,
} from '../../../helpers/dateFormat';
import { createErrorMessage, createSuccessMessage } from '../../../helpers/notification';
import HomeworkForm from './HomeworkForm/index';

class HomeworkContainer extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    materiaPeriodoId: PropTypes.number.isRequired,
    utilizaPorcentajePesoMateria: PropTypes.bool.isRequired,
    finCalificarTareas: PropTypes.string.isRequired,
    canEdit: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 10 },
      showForm: false,
      recordId: 0,
    };

    this.handleSubmit.bind(this);

    this.checkBoxLabelStyle = {
      marginTop: '0px',
      display: 'flex',
      justifyContent: 'center',
    };

    this.columns = utilizaPorcentajePesoMateria => [
      { key: 'id', name: '#', width: '85px' },
      {
        key: 'descripcion', name: 'Tarea', width: '85px', search: true,
      },
      {
        key: 'tipoTarea',
        name: 'Tipo Tarea',
        width: '85px',
        className: 'text-center',
        format: row => `${row.tipoTarea.label}`,
      },
      {
        key: 'puntajeTotal',
        name: 'Puntaje Total',
        width: '85px',
        className: 'text-center',
        format: row => `${row.puntajeTotal}`,
      },
      {
        key: 'porcentajePesoMateria',
        name: 'Porcentaje Peso Materia',
        width: '85px',
        className: 'text-center',
        format: row => `${utilizaPorcentajePesoMateria ? row.porcentajePesoMateria : 'Sin Peso'}`,
      },
      {
        key: 'fechaEntrega',
        name: 'Fecha Entrega',
        search: false,
        className: 'text-center',
        width: '150px',
        format: row => dateFormat(row.fechaEntrega),
      },
      {
        key: 'actions',
        name: 'Accion',
        width: '85px',
        className: 'text-center',
      },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar" />,
        callback: (record) => {
          this.edit(record);
        },
      },
      {
        key: 'delete',
        visible: false,
        icon: row => (
          <>
            <span id={`UncontrolledPopover${row.id}`} className="fa fa-trash" title="Borrar" />
            <UncontrolledPopover
              trigger="legacy"
              placement="left"
              target={`UncontrolledPopover${row.id}`}
              className="info"
              disabled={!row.cantidadInscriptos}
            >
              <PopoverHeader>No se puede borrar la tarea</PopoverHeader>
              <PopoverBody>Hay alumnos que entregaron la tarea.</PopoverBody>
            </UncontrolledPopover>
          </>
        ),
        callback: (record) => {
          if (!record.cantidadInscriptos) {
            this.handleDeleteAction(record);
          }
        },
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateTable(page, pageSize);
  }

  updateTable = (page, pageSize, filters) => {
    const {
      materiaPeriodoId,
    } = this.props;

    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });

    filterHomework({
      materiaPeriodoId,
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: ({ items, totalItemsCount }) => {
        this.setState({
          loading: false,
          items,
          totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de materias por periodo');
      },
    });
  }

  handleDeleteAction = (record) => {
    const name = `${record.descripcion}`;
    Confirm({
      title: 'Borrar tarea de clase',
      question: `Estás seguro que deseas eliminar esta tarea "${name}"?`,
      yesLabel: 'Si, Borrar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        removeHomework(record.id, {
          onSuccess: () => {
            createSuccessMessage('Tarea borrado exitosamente');
            const { page, pageSize } = this.state;
            this.updateTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La tarea no existe');
            } else {
              createErrorMessage('Error al intentar borrar tarea');
            }
          },
        });
      },
    });
  };

  handleHideForm = () => {
    this.setState({
      showForm: false,
      recordId: 0,
    });

    this.onDataTableClearFilters();
  };

  edit = (record) => {
    this.setState({
      showForm: true,
      recordId: record.id,
    });
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize, filters } = this.state;
    const { autoHideSearch } = filters;
    this.updateTable(1, pageSize, { autoHideSearch });
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  handleSubmit = () => {
    const { handleSubmit } = this.props;
    const { utilizaPorcentajePesoMateria } = this.state;

    handleSubmit({ utilizaPorcentajePesoMateria });
  };

  handleChangeChecked = (utilizaPorcentajePesoMateria) => {
    if (utilizaPorcentajePesoMateria === undefined) {
      return;
    }

    this.setState({ utilizaPorcentajePesoMateria });

    const { handleSubmit } = this.props;

    handleSubmit({ utilizaPorcentajePesoMateria });
  };

  render() {
    const {
      loading,
    } = this.state;

    const {
      finCalificarTareas,
    } = this.props;

    if (loading || !finCalificarTareas) {
      return <LoadingSpinner />;
    }

    const {
      materiaPeriodoId,
      utilizaPorcentajePesoMateria,
      canEdit,
    } = this.props;

    const {
      showForm,
      recordId,
    } = this.state;

    if (showForm) {
      return (
        <HomeworkForm
          id={recordId}
          materiaPeriodoId={materiaPeriodoId}
          utilizaPorcentajePesoMateria={utilizaPorcentajePesoMateria}
          finCalificarTareas={finCalificarTareas}
          onHideForm={this.handleHideForm}
        />
      );
    }

    const {
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    if (!dateTimeFormat(finCalificarTareas)) {
      return null;
    }

    return (
      <Container>
        <Row>
          <Col md={3} sm={5}>
            <h4 className="mt-2 mb-2">
              <Badge color={canEdit ? 'primary' : 'warning'} style={{ textWrap: 'wrap' }}>
                {`Fecha Límite Calificar Tareas ${dateTimeFormat(finCalificarTareas)}`}
              </Badge>
            </h4>
            {canEdit ? (
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => this.edit({ id: 0 })}
              >
                <i className="fa fa-plus" /> Agregar Nueva Tarea
              </button>
            ) : null
            }
          </Col>
          <Col md={9} sm={7}>
            <div style={{ display: 'flex', alignItems: 'flex-end', marginTop: '12px' }}>
              {
                canEdit ? (
                  <Form
                    inline="true"
                    className="form"
                    name="HomeworkContainer"
                    onSubmit={this.handleSubmit}
                  >
                    <Col md={12} lx={6}>
                      <div
                        className="form__form-group"
                        style={{
                          display: 'flex',
                          marginBottom: '1px',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <span className="form__form-group-label ">Utiliza Porcentaje Peso</span>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <h4><Badge color={utilizaPorcentajePesoMateria ? 'secondary' : 'warning'}>No</Badge></h4>
                          <div className="form__form-group-field" style={{ width: 'auto', margin: '0 0 0 10px' }}>
                            <Field
                              labelStyle={this.checkBoxLabelStyle}
                              name="utilizaPorcentajePesoMateria"
                              component={renderToggleButtonField}
                              value={utilizaPorcentajePesoMateria}
                              onChange={this.handleChangeChecked}
                            />
                          </div>
                          <h4><Badge color={!utilizaPorcentajePesoMateria ? 'secondary' : 'success'}>Si</Badge></h4>
                        </div>
                      </div>
                    </Col>
                  </Form>
                ) : null
              }

            </div>
          </Col>
        </Row>
        <Row>
          <DataTable
            title="Listado de todas las tareas de clase"
            columns={this.columns(utilizaPorcentajePesoMateria)}
            items={items}
            onChangePage={this.onChangePage}
            totalItemsCount={totalItemsCount}
            onSubmit={this.onDataTableSubmit}
            onClearFilters={this.onDataTableClearFilters}
            getGridActions={key => this.getGridActions(key)}
            onAutoSave={this.autoguardarNota}
            itemsToShow={items.length}
            page={page}
            pageSize={pageSize}
            autoHideSearch={filters.autoHideSearch}
            initialValues={filters}
            enableReinitialize
          />
        </Row>
      </Container>
    );
  }
}

const ReduxHomeworkContainer = reduxForm({
  form: 'HomeworkContainer',
  // validate,
  enableReinitialize: true,
})(HomeworkContainer);

export default setPropsAsInitialValues(ReduxHomeworkContainer);
